import React from 'react';

export const groupElements = (elements: JSX.Element[]) => {
  let group: JSX.Element[] = [];

  return elements
    .map((element, index) => {
      if (!isPartOfAGroup(element)) {
        return element;
      }
      group.push(element);
      if (index >= elements.length || !isPartOfAGroup(elements[index + 1])) {
        const result = displayGroup(group);
        group = [];
        return result;
      }
      return undefined;
    })
    .filter(Boolean) as JSX.Element[];
};

const isPartOfAGroup = (element: JSX.Element) => element?.key !== null && (element?.key as string).includes('_group');

const displayGroup = (elements: JSX.Element[]) => (
  <div key={`group-${elements.map((el) => el?.key).join('-')}`} className={`grid grid-cols-2 md:grid-cols-${elements.length} gap-3`}>
    {elements}
  </div>
);
